module.exports = __webpack_public_path__ + "img/v2.62fc9ba.png";